import { createStore, combineReducers } from "redux";
import reducers from "../reducers/index";
export const store = createStore(combineReducers({
    state: reducers
}));
